import { GetProductPageQuery } from '@productsite-beta/src/graphql/generated/graphql-types'

export type ProductPageType = NonNullable<
    NonNullable<NonNullable<GetProductPageQuery['productPageE4']>['productResult']>
>
export type SpecificationsListType = NonNullable<ProductPageType['allSpecifications']>
export type PageDisplayDataType = NonNullable<ProductPageType['pageDisplayData']>

export const ProductPageTabNames: readonly [
  'accessories',
  'description',
  'reviews',
  'specification',
  'documents'
] = ['accessories', 'description', 'reviews', 'specification', 'documents'] as const
export type ProductPageTabName = (typeof ProductPageTabNames)[number]
